import React, { Component } from 'react';
class Group extends Component {
  render() {
    return (
        <div {...this.props} className={`field ${this.props.className}`}>
          {this.props.children}
          {this.props.errors && <span className="helper">{this.props.errors.join(', ')}</span>}
        </div>
    );
  }
}

export default Group;
